import React from 'react';
import WizardInputSkeleton from 'components/v2/epd-wizard-inputs/WizardInputSkeleton';
import SelectorButtonSkeleton from 'components/v2/buttons/SelectorButtonSkeleton';
import { FieldPanelFullWidth } from 'styles/v2/Styles.styled';
import { Skeleton } from 'primereact/skeleton';

const SkeletonPcrLcaAndVerificationTab: React.FC<{}> = () => {
  return (
    <>
      {/* PCR */}
      <FieldPanelFullWidth>
        <Skeleton width="10rem" />

        <SelectorButtonSkeleton />
      </FieldPanelFullWidth>

      {/* LCA */}
      <FieldPanelFullWidth>
        <Skeleton width="10rem" />
        <WizardInputSkeleton />
      </FieldPanelFullWidth>

      {/* Verification */}
      <FieldPanelFullWidth>
        <Skeleton width="10rem" />

        {Array(4)
          .fill(0)
          .map((_, i) => (
            <WizardInputSkeleton key={i} />
          ))}
      </FieldPanelFullWidth>
    </>
  );
};

export default SkeletonPcrLcaAndVerificationTab;
